import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-industries',
  imports: [TranslateModule],
  templateUrl: './industries.component.html',
  styleUrl: './industries.component.scss',
})
export class IndustriesComponent {
  readonly industries = [
    {
      title: 'industries.items.perishables.title',
      description: 'industries.items.perishables.description',
      image:
        'https://lh3.googleusercontent.com/aida-public/AB6AXuDjwhT-gbqaGnoDi5aRPOVOvS1wYL_RuPGGOv_iaYIlk03jhhya2WTuMJQDzUlcINCwUMBf2FIk0h0eIR86iKTsd2DUrZGmebVTMhRCayiWBwPknFGMNCfGBi3k8ZDxfONWbSNbpWYu4dt5y9mLZg8j_5nmZ0CioPcehLNmZlmI82aBVAf_hKxIfMf_gkj4K_vwL7S00Ubbr7ZprCnr1N6kHog2mJlFcUfbnTlgjzlZQoirPhncZlmwgETYnGsl5xNOpHJTpfObGwgX',
      alt: 'industries.items.perishables.alt',
    },
    {
      title: 'industries.items.textiles.title',
      description: 'industries.items.textiles.description',
      image:
        'https://lh3.googleusercontent.com/aida-public/AB6AXuDTaYMyUa5-g6P-h7s3P33sQ0coaa4aEHUEfGGRdT3sEWaSbzLLKjLJg3H2JT8A25QJ7Kk0cAL6yasImKglp1sBzddtLWhyDJeayBSh50ev6ZqcyISJw_-a5D34iUEG-cbXGuQCn0f1qks760H7x9ppJhhVgb-zIx91iJP8eaEpJmbc8-3i4gBF4DDFPp0bUdugusrPy0H1Ybieix9JGjBjDCYOtPjb90RYS-SAkEYvl0yeLor6-7hcyN2nayXqQdDs-1qwpge0QJTa',
      alt: 'industries.items.textiles.alt',
    },
    {
      title: 'industries.items.industrial.title',
      description: 'industries.items.industrial.description',
      image:
        'https://lh3.googleusercontent.com/aida-public/AB6AXuCxphKjxy0h6q19l_PzU0tV3yeTFIAA829Nyt8SO2EQD0RQZXw6685txFY5-sZhP67hH-vW47ygxunCYwPJnAXFv6vD6nYH6LFEN4YkrYj3kA7BGdsuLZmBx4KP8rOockT-GuvPfWYgswATk7SXI2v2msJtyoSZWf-Xu20IOMXVlIHxSd3R-VxttTDgk4h3IliOfSoI-S2ODl5Uyn_G5KlGg29WPhPRyqlXh9QczrvmymmWLfb61AxaHXjIZxzZCX8eWA2cEUij2RKW',
      alt: 'industries.items.industrial.alt',
    },
    {
      title: 'industries.items.chemicals.title',
      description: 'industries.items.chemicals.description',
      image:
        'https://lh3.googleusercontent.com/aida-public/AB6AXuD3qztiaz9ymRt-GM4lhlLWuY0nvgXZRzJj_Sk3QlcMYhYTKAH2Gm3Pyrvf1QQccbBfXaL9NfegPDTbeWBFIScr1Nv4pFBg6KRmdBrJbpneB3GkOs7XtzQgtMmg5Ld8USFgvD-RMe39_zpuysMjvqlGY7Ak__NS6uYWtphxwjJkn2fzc0oEdQwVT2Nd8QUb4LdX8ySd1TSy9vyBqp-VQsO2mXkMbgzI-geXvT5YQ-KrA8oSiR-0X_rUxz1eW9nGvzwUYU_5LH7bJKg8',
      alt: 'industries.items.chemicals.alt',
    },
  ];
}
